export type { IInputProps } from './input';

export { default } from './input';
export { TextArea } from './textarea';
